import type { TourStepProps } from "antd";
import type { TourContext } from "./raidTourStore";

function target(selector: string): TourStepProps["target"] {
  return () => document.querySelector(selector) as HTMLElement;
}

const raidListSteps: TourStepProps[] = [
  {
    title: "Raid erstellen",
    description:
      "Klicke hier, um einen neuen Raid zu erstellen. " +
      "Der Name wird automatisch mit dem heutigen Datum generiert.",
    target: target('[data-tour="raid-create-btn"]'),
    placement: "bottomRight",
  },
];

const raidEditCreatedSteps: TourStepProps[] = [
  {
    title: "Raid-Name",
    description: "Hier kannst du den Raid-Namen anpassen und mit Enter oder dem Stift-Icon speichern.",
    target: target('[data-tour="raid-name"]'),
    placement: "bottom",
  },
  {
    title: "Status-Anzeige",
    description: "Hier werden Status, Dauer und Gesamtressourcen des Raids angezeigt.",
    target: target('[data-tour="raid-status"]'),
    placement: "bottom",
  },
  {
    title: "Ressourcen hinzufügen",
    description:
      "Wähle den Ressourcentyp (Spice, Titanium, Stravidium), gib die Menge ein und bestätige mit Enter oder dem Plus-Icon.",
    target: target('[data-tour="add-resource"]'),
    placement: "bottom",
  },
  {
    title: "Spieler eintragen",
    description:
      "Trage hier die Spielernamen ein, die am Raid teilnehmen. Bestätige mit Enter oder dem Plus-Icon.",
    target: target('[data-tour="add-participant"]'),
    placement: "bottom",
  },
  {
    title: "Raid starten",
    description:
      "Wenn alle Spieler und Ressourcen eingetragen sind, starte den Raid über diesen Button. " +
      "Danach beginnt die Zeitmessung.",
    target: target('[data-tour="raid-start-btn"]'),
    placement: "bottomLeft",
  },
];

const raidEditRunningSteps: TourStepProps[] = [
  {
    title: "Zeit starten / stoppen",
    description:
      "Steuert die Zeitmessung pro Spieler. Läuft die Zeit, kannst du sie mit 'Zeit stoppen' pausieren. " +
      "Steht die Zeit still, setzt 'Zeit starten' sie fort. Die gemessene Zeit fließt in die Spice-Verteilung ein.",
    target: target('[data-tour="time-toggle"]'),
    placement: "left",
  },
  {
    title: "Spieler hinzufügen",
    description:
      "Auch während eines laufenden Raids kannst du weitere Spieler hinzufügen. " +
      "Name eingeben und mit Enter oder dem Plus-Icon bestätigen.",
    target: target('[data-tour="add-participant"]'),
    placement: "bottom",
  },
  {
    title: "Spieler entfernen",
    description:
      "Entfernt einen Spieler aus dem Raid. Die bisherige Zeitmessung dieses Spielers wird verworfen.",
    target: target('[data-tour="remove-participant"]'),
    placement: "left",
  },
  {
    title: "Spice Rechner",
    description:
      "Öffne den Spice Rechner, um die Melange-Verteilung basierend auf dem gesammelten Spice-Sand zu berechnen.",
    target: target('[data-tour="spice-calculator"]'),
    placement: "bottom",
  },
  {
    title: "Raid beenden",
    description:
      "Beendet den Raid und stoppt alle laufenden Zeitmessungen. " +
      "Danach werden die Ergebnisse pro Spieler sichtbar.",
    target: target('[data-tour="raid-stop-btn"]'),
    placement: "bottomLeft",
  },
];

const stepsByContext: Record<TourContext, TourStepProps[]> = {
  "raid-list": raidListSteps,
  "raid-edit-created": raidEditCreatedSteps,
  "raid-edit-running": raidEditRunningSteps,
};

export function getStepsForContext(ctx: TourContext): TourStepProps[] {
  return stepsByContext[ctx] ?? [];
}
